
(function ($, window, document, undefined) {
    var lema = {};

    $(document).ready(function () {

        // LEMA: SLIDER

        lema.slider = $('.lema-overview .lema-slider');

        if (lema.slider.length) {

            lema.items = $('.lema-overview .lema-slider .lema-slider-item');

            lema.navigation = $('.lema-overview .lema-navigation');

            lema.inner = $('.lema-overview .lema-navigation .lema-navigation-inner');

            lema.list = $('.lema-overview .lema-navigation .lema-list-item');

            lema.label = $('.lema-overview .lema-navigation .lema-list-item .lema-list-item-label ');

            lema.prev = $('.lema-overview .lema-slider-prev');

            lema.next = $('.lema-overview .lema-slider-next');

            lema.options = {
                dots: false,
                infinite: true,
                speed: 800,
                arrows: false,
                slidesToShow: 1,
                autoplaySpeed: 4000,
                adaptiveHeight: false,
                pauseOnHover: true
            };

            lema.options.autoplay = lema.slider.hasClass('noAutoplay') ? false : true;

            lema.label.on('click', function () {
                lema.navigation.removeClass('active');
                lema.slider.slick('slickGoTo', $(this).parent().index());
            });

            lema.navigation.on('click', '.lema-navigation-select', function () {
                $(this).parent(lema.navigation).toggleClass('active');
            });

            lema.prev.on('click', function () {
                lema.slider.slick('slickPrev');
            });

            lema.next.on('click', function () {
                lema.slider.slick('slickNext');
            });

            lema.slider.on('init', function () {
                lema.first = lema.list.first();
                lema.first.find('input').prop('checked', true);
                lema.select = $('<p class="lema-navigation-select">' + $(lema.first.find('label').contents()[0]).text() + '</p>')
                lema.inner.before(lema.select);
            });

            lema.slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                lema.select.text($(lema.label.eq(nextSlide).contents()[0]).text());
                lema.list.eq(nextSlide).find('input').prop('checked', true);
            });

            lema.slider.slick(lema.options);

        }

        // LEMA: WIDGET

        lema.widget = {
            wrapper: $('.lema-widget'),
            button: $('.lema-widget .widget-button'),
            custom: $('.lema-widget .widget-button.widget-custom-amount .widget-amount'),
            update: function () {
                lema.widget.amount = 0;
                if (lema.widget.this.hasClass('active')) {
                    lema.widget.text = lema.widget.this.find('.widget-amount');
                    lema.widget.value = lema.widget.text.val() ? parseInt(lema.widget.text.val()) : parseInt($(lema.widget.text.contents()[0]).text());
                    lema.widget.amount = isNaN(lema.widget.value) ? 0 : lema.widget.value;
                }
                lema.widget.card.find('.widget-input-amount').val(lema.widget.amount);
            }
        };

        lema.widget.button.on('click', function () {
            lema.widget.this = $(this);
            lema.widget.card = lema.widget.this.closest('.lema-widget');
            if (lema.widget.this.hasClass('active')) {
                lema.widget.this.removeClass('active');
            } else {
                lema.widget.card.find('.widget-button').removeClass('active');
                lema.widget.this.addClass('active');
            }
            lema.widget.update();
        });

        lema.widget.custom.on('change keyup paste mouseup', function () {
            lema.widget.this = $(this).closest('.widget-button');
            lema.widget.card = lema.widget.this.closest('.lema-widget');
            lema.widget.update();
        });

        // LEMA: SHARE

        lema.share = $('.lema-share');

        if (lema.share.length) {
            // show whatsapp link only for mobile
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                lema.share.find('.whatsapp').addClass('active');
            }
        }

    });

})(jQuery, window, document);
